<script setup>
  const props = defineProps({
    prefix: String
  })

</script>
<template>

  <div>
    <div class="relative mt-4 mb-6">
      <div class="absolute inset-0 flex items-center" aria-hidden="true">
        <div class="w-full border-t border-slate-200" />
      </div>
      <div class="relative flex justify-center text-sm font-light leading-6">
        <span class="rounded-full bg-slate-100 px-6 text-slate-700 lowercase">or {{ props?.prefix }}</span>
      </div>
    </div>

    <div class="my-4 hid-den grid grid-cols-1 sm:grid-cols-2 justify-center gap-4">
      <a href="#" class="mb-4 flex w-full items-center justify-center gap-3 bg-white px-3 py-2 text-xs font-semibold text-slate-600 uppercase">
        <svg class="h-4 w-4" aria-hidden="true" viewBox="0 0 24 24">
          <path d="M12.0003 4.75C13.7703 4.75 15.3553 5.36002 16.6053 6.54998L20.0303 3.125C17.9502 1.19 15.2353 0 12.0003 0C7.31028 0 3.25527 2.69 1.28027 6.60998L5.27028 9.70498C6.21525 6.86002 8.87028 4.75 12.0003 4.75Z" fill="#EA4335" />
          <path d="M23.49 12.275C23.49 11.49 23.415 10.73 23.3 10H12V14.51H18.47C18.18 15.99 17.34 17.25 16.08 18.1L19.945 21.1C22.2 19.01 23.49 15.92 23.49 12.275Z" fill="#4285F4" />
          <path d="M5.26498 14.2949C5.02498 13.5699 4.88501 12.7999 4.88501 11.9999C4.88501 11.1999 5.01998 10.4299 5.26498 9.7049L1.275 6.60986C0.46 8.22986 0 10.0599 0 11.9999C0 13.9399 0.46 15.7699 1.28 17.3899L5.26498 14.2949Z" fill="#FBBC05" />
          <path d="M12.0004 24.0001C15.2404 24.0001 17.9654 22.935 19.9454 21.095L16.0804 18.095C15.0054 18.82 13.6204 19.245 12.0004 19.245C8.8704 19.245 6.21537 17.135 5.2654 14.29L1.27539 17.385C3.25539 21.31 7.3104 24.0001 12.0004 24.0001Z" fill="#34A853" />
        </svg>
        <span class="text-xs leading-6 tracking-widest">Google</span>
      </a>

      <a href="#" class="mb-4 flex w-full items-center justify-center gap-3 bg-white px-3 py-2 text-xs font-semibold text-slate-600 uppercase">
        <svg class="h-4 w-4 fill-[#24292F]" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clip-rule="evenodd" />
        </svg>
        <span class="text-xs leading-6 tracking-widest">GitHub</span>
      </a>

      <a href="#" class="mb-4 flex w-full items-center justify-center gap-3 bg-white px-3 py-2 text-xs font-semibold text-slate-600 uppercase">
        <svg class="h-5 w-5" aria-hidden="true" viewBox="0 0 512 512"
          aria-label="LinkedIn" role="img" fill="#fff">
          <path d="m0 0H512V512H0" fill="#0077b5"/>
          <circle cx="142" cy="138" r="37"/>
          <path stroke="#fff" stroke-width="66" d="M244 194v198M142 194v198"/>
          <path d="M276 282c0-20 13-40 36-40 24 0 33 18 33 45v105h66V279c0-61-32-89-76-89-34 0-51 19-59 32"/>
        </svg>
        <span class="text-xs leading-6 tracking-widest">Linkedin</span>
      </a>

      <a href="#" class="mb-4 flex w-full items-center justify-center gap-3 bg-white px-3 py-2 text-xs font-semibold text-slate-600 uppercase">
        <svg class="h-6 w-6" aria-hidden="true" viewBox="0 0 512 512"
          aria-label="Facebook" role="img">
          <path d="m0 0H512V512H0" fill="#fff"/>
          <path d="m331 312h-45v134a192 192 0 10-60 0V312h-49v-56h49v-45q4-89 116-68v47h-26q-29 1-30 30v36h53.5" fill="#1877f2"/>
        </svg>        
        <span class="text-xs leading-6 tracking-widest">Facebook</span>
      </a>
      
    </div>
  </div>
</template>